module.exports = __webpack_public_path__ + "static/p08_cerditoTop-c387dd0ecbd9c63dfbd8ab745fbc1709.png";